/**
 * コレクション一覧: URL キーワードでカードを絞り込み（dreampiece.jp contents-index 準拠）
 */
(function () {
  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function getQueryParam(name) {
    if (!name) {
      return '';
    }
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  function setQueryParam(name, value) {
    const url = new URL(window.location.href);
    const trimmed = String(value || '').trim();
    if (trimmed) {
      url.searchParams.set(name, trimmed);
    } else {
      url.searchParams.delete(name);
    }
    window.history.replaceState({}, '', url.toString());
  }

  function filterCollectionCards(root, query) {
    const cards = Array.from(root.querySelectorAll('[data-dreampiece-collection-card]'));
    const empty = root.querySelector('[data-dreampiece-collection-empty]');
    const keyword = normalize(query);

    let visibleCount = 0;

    cards.forEach((card) => {
      const title = normalize(card.dataset.searchTitle);
      const desc = normalize(card.dataset.searchDesc);
      const matched = !keyword || title.includes(keyword) || desc.includes(keyword);

      card.classList.toggle('is-hidden', !matched);
      if (matched) {
        visibleCount += 1;
      }
    });

    if (empty) {
      const showEmpty = keyword && visibleCount === 0;
      empty.classList.toggle('hidden', !showEmpty);
      empty.hidden = !showEmpty;
    }
  }

  function initCollectionSearch(root) {
    if (!root || root.dataset.dreampieceCollectionBound === '1') {
      return;
    }

    const paramName = root.dataset.searchParam || 'q';
    const form = root.querySelector('[data-dreampiece-collection-search]');
    const input = root.querySelector('[data-dreampiece-collection-search-input]');

    if (!form || !input) {
      return;
    }

    root.dataset.dreampieceCollectionBound = '1';

    const initialQuery = getQueryParam(paramName);
    input.value = initialQuery;
    filterCollectionCards(root, initialQuery);

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = input.value;
      setQueryParam(paramName, query);
      filterCollectionCards(root, query);
    });
  }

  function boot() {
    document.querySelectorAll('[data-dreampiece-collection]').forEach(initCollectionSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-dreampiece-collection]');
    if (root) {
      initCollectionSearch(root);
    }
  });
})();
